import { axiosInstance } from "./AxiosInstance";

const API_URL = "/departments";
const DEPARTMENTS_PAGE_CAP = 100;
const DEPARTMENTS_DEFAULT_LIMIT = 10;

// Matches the { data, pagination } shape AsyncPagedSelect's `fetchPage` needs
// — same pattern as getBranches/getTrainers/getcourses elsewhere in this app.
export const getDepartments = async (limit = 10, page = 1, search = "") => {
  try {
    const safeLimit = Math.max(1, Math.min(DEPARTMENTS_PAGE_CAP, Number.parseInt(limit, 10) || DEPARTMENTS_DEFAULT_LIMIT));
    const safePage = Math.max(1, Number.parseInt(page, 10) || 1);
    const response = await axiosInstance.get(
      `${API_URL}?limit=${safeLimit}&page=${safePage}&search=${search || ""}`
    );
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    };
  } catch (error) {
    console.error("Error fetching departments", error);
    throw error;
  }
};
